/**
 * Итог отправки по снимку записи (см. persistAfterPush в timesheetSyncService).
 *
 * Пока снимок летел на сервер, запись могли поправить на айпаде. Тогда итог
 * отправки по старому снимку НЕ пишем: свежая правка уйдёт следующей отправкой,
 * от сервера берём только serverId. Раньше итог ложился поверх — «поставил 6,
 * через миг снова 7» (10/15).
 *
 * @param {object|undefined} current запись в базе сейчас
 * @param {object} snapshot запись, какой её отправили
 * @param {object} patch что записать по итогу (syncStatus, serverId, …)
 * @param {{ PENDING: string, SYNCING: string }} statuses
 * @returns {object} что положить в базу
 */
export function recordAfterPush(current, snapshot, patch, statuses) {
    const editedMeanwhile = current
        && (String(current.updatedAt || '') !== String(snapshot.updatedAt || '')
            || (current.localVersion || 0) !== (snapshot.localVersion || 0));
    if (!editedMeanwhile) return { ...snapshot, ...patch };

    const record = { ...current };
    if (patch.serverId && !current.serverId) record.serverId = patch.serverId;
    if (record.syncStatus === statuses.SYNCING) record.syncStatus = statuses.PENDING;
    // Разовый запрос письма с PDF ушёл с этим снимком — сервер его выполнил.
    if (patch.emailPdf === false && snapshot.emailPdf) record.emailPdf = false;
    return record;
}
